<template>
  <div>
    <DialogBase
        :visible="isDialogVisible"
        title="Cài đặt thời gian hết hạn ghim"
        width="500px"
        panel-icon="el-icon-time"
        panel-title="Thiết lập ngày bỏ ghim"
        panel-subtitle="Tin ghim sẽ tự động hết hạn theo ngày bạn chọn"
        @update:visible="handleVisibleUpdate"
    >
      <div style="display: flex; margin-top: 10px; margin-bottom: 30px">
        <span style="margin-right: 10px">
          Ngày hết hạn:
        </span>
        <div>
          <el-date-picker
              v-model="initialData.endPinDate"
              type="date"
              placeholder="Chọn ngày bỏ ghim"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              :clearable="false"
          />
        </div>
      </div>

      <div slot="footer" class="dialog-footer sk-dialog-footer">
        <el-button type="success" @click="handleConfirm">
          <i class="el-icon-circle-check"/>
          Lưu
        </el-button>

        <el-button type="danger" @click="clickBtnClose">
          <i class="el-icon-circle-close"/>
          Đóng
        </el-button>
      </div>
    </DialogBase>
  </div>
</template>

<script>
import NotifyTeacherService from "@/services/TeacherService/NotifyTeacherService";
import DialogBase from "@/components/DialogBase.vue";

export default {
  components: { DialogBase },
  props: {
    isDialogVisible: null,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      initialData: {
        id: null,
        pin: Boolean,
        endPinDate: null,
      },

      isSave: false,
    }
  },

  mounted() {
    this.setEndPinDate();
  },

  methods: {
    handleVisibleUpdate(value) {
      if (!value) {
        this.clickBtnClose();
      }
    },
    setEndPinDate() {
      let today = new Date();
      let tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      // Format lại ngày thành yyyy-MM-dd
      let year = tomorrow.getFullYear();
      let month = String(tomorrow.getMonth() + 1).padStart(2, '0');
      let day = String(tomorrow.getDate()).padStart(2, '0');

      this.initialData.endPinDate = `${year}-${month}-${day}`;
    },

    handleConfirm() {
      this.fetchSetPinPost()
    },

    handleCloseDialog() {
      const id = this.initialData.id;
      const pin = this.initialData.pin;
      const isSave = this.isSave;

      this.setEndPinDate();
      this.$emit("dialogClose", {id, pin, isSave});
    },

    clickBtnClose() {
      this.initialData.pin = !this.initialData.pin;
      this.isSave = false;

      this.handleCloseDialog();
    },

    handleSetInitialData(id, pin) {
      this.initialData.id = id;
      this.initialData.pin = pin;
    },

    fetchSetPinPost() {
      const param = {
        id: this.initialData.id,
        pin: this.initialData.pin,
        endPinDate: this.initialData.endPinDate,
      }
      NotifyTeacherService.setPinPost(param)
          .then((res) => {
            this.initialData.pin = res.data.data;
            this.isSave = true;

            this.handleCloseDialog();
            this.$message({
              message: res.data.message,
              type: "success",
              duration: 5000
            })
          })
          .catch((err) => {
            console.error(err);
          })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/ .is_err {
  .el-input__inner {
    border: 1px solid #F56C6C;
    color: #F56C6C;
  }
}

.err_message {
  color: #F56C6C;
  margin-top: 4px;
  font-size: 12px;
}
</style>
